import Vue from 'vue';
export const MessageEvent = new Vue();
